import Work1 from "../../assets/hos.png";
import Work2 from "../../assets/todo.png";
import Work3 from "../../assets/weather.png";
import Work4 from "../../assets/titanic.png";
import Work5 from "../../assets/Cust.png";
import Work6 from "../../assets/Work6.png";
import Work7 from "../../assets/Work7.png";
import Work8 from "../../assets/ibm.png";
import Work9 from "../../assets/streamlit.png";

const Menu = [
	{
	    id: 1,
		image: Work9,
		title: "IMDB Sentiment Analysis App",
		category: ["Data Science"],
		url: "https://lstm-imbd-movie-sentiment-analysis.streamlit.app/",
		repositoryUrl: "https://github.com/ayushsingh991399/LSTM_IMBD_Movie_Sentiment_Analysis/tree/main"
     },
	{
	    id: 2,
		image: Work8,
		title: "IBM HR ATTENTION Prediction App",
		category: ["Data Science"],
		url: "https://ibm-hr-analytic-attrition.streamlit.app/",
		repositoryUrl: "https://github.com/ayushsingh991399/Midterm_Project_IBM_HR_Analytic_Attrition"
     },
	{
	    id: 3,
		image: Work6,
		title: " Medical PDF Chatbot",
		category: ["Data Science"],
		url: "https://github.com/ayushsingh991399/End_To_End_Medical_chatbot_Langchain",
		repositoryUrl: "https://github.com/ayushsingh991399/End_To_End_Medical_chatbot_Langchain"
     },
	{
		id: 4,
		image: Work7,
		title: "MCQ Generator and Evaluator",
		category: ["Data Science"],
		url: "https://github.com/ayushsingh991399/MCQ-Generator-and-Evaluator",
		repositoryUrl: "https://github.com/ayushsingh991399/MCQ-Generator-and-Evaluator"
	},
	{
	    id: 5,
		image: Work5,
		title: "Customer Churn Prediction App",
		category: ["Data Science"],
		url: "https://customerchurnprediction12.streamlit.app/",
		repositoryUrl: "https://github.com/ayushsingh991399/Customer_Churn_Prediction"
     },
	{
		id: 6,
		image: Work4,
		title: "Titanic Survival Prediction App",
		category: ["Data Science"],
		url: "https://titanicsurvival-survival.streamlit.app/",
		repositoryUrl: "https://github.com/ayushsingh991399/Titanic_survival"
	},
	{
		id: 7,
		image: Work1,
		title: "Hospital Managment App",
		category: ["Frontend", "React"],
		url:"https://hospital-managment-system-orpin.vercel.app/",
		repositoryUrl: "https://github.com/ayushsingh991399/HospitalManagmentSystem"
	},
	{
		id: 8,
		image: Work2,
		title: "Todo App",
		category: ["Frontend", "React"],
		url: "https://todo-1-two.vercel.app/",
		repositoryUrl: "https://github.com/ayushsingh991399/Todo_1"
	},
	{
		id: 9,
		image: Work3,
		title: "Weather App",
		category: ["Frontend","React"],
		url: "https://weather-app-sand-one-44.vercel.app/",
		repositoryUrl: "https://github.com/ayushsingh991399/Weather_app"
	}
	
];

export default Menu;
